import { ActivatedRouteSnapshot, CanActivateFn, RouterStateSnapshot } from '@angular/router';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';

/**
 * `autoLoginPartialRoutesGuard` passa il `data` della rotta come customParams del login (query string di
 * /authorize e storage), quindi anche EMC e catena delle voci: alla libreria si passa uno snapshot che eredita
 * da quello vero ma senza `data`, lasciando intatto l'originale.
 */
export const NoRouteDataAutoLoginPartialRouteGuardFunction: CanActivateFn = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot
) => {
  const routeWithoutData = Object.create(route, { data: { value: undefined } }) as ActivatedRouteSnapshot;
  return autoLoginPartialRoutesGuard(routeWithoutData, state);
};
